import React from "react";
import { useLocation } from "react-router-dom";
import "./ZtpPolicy.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ZtpPolicy = () => {
  const query = useQuery();
  const language = query.get("language") || "en";

  return (
    <div className="ztp-container">
      {language.toLowerCase() === "hi" ? (
        <>
          <h1>ज़ीरो टॉलरेंस पॉलिसी (ZTP) @ Zingbus</h1>
          <hr />
          <p>
            Zingbus में हमारी ज़ीरो टॉलरेंस पॉलिसी (ZTP) उन व्यवहारों को परिभाषित
            करती है जिन्हें किसी भी परिस्थिति में स्वीकार नहीं किया जाएगा। ऐसे
            मामलों में तुरंत कड़ी कार्रवाई की जाएगी, जिसमें ड्यूटी से तत्काल
            हटाना, वेतन की हानि और स्थायी निलंबन (ब्लैकलिस्टिंग) शामिल है।
          </p>

          <p>
            <strong>नीचे दिए गए मामलों को ZTP माना जाएगा:</strong>
          </p>

          <ol>
            <li>
              <strong>ग्राहक के साथ मौखिक या शारीरिक अव्यवहार:</strong>
              <p>
                हम अपने ग्राहकों को महत्व और सम्मान देते हैं और उन्हें घर आए
                मेहमान जैसा मानते हैं। किसी भी परिस्थिति में — चाहे ग्राहक कितना
                भी नाराज़ या उत्तेजित क्यों न हो — हमें उनसे बहस नहीं करनी है।
                इसके बजाय, हमें सहानुभूति (Empathy) दिखाकर उनकी समस्या को समझने
                का प्रयास करना चाहिए।
              </p>
              <p>
                यदि आपको लगता है कि आप स्थिति को नियंत्रित नहीं कर पा रहे हैं,
                तो तुरंत Crew Chat टीम से सहायता लें। किसी भी परिस्थिति में
                ग्राहक पर मौखिक या शारीरिक हमला करना समाधान नहीं है।
              </p>
            </li>

            <li>
              <strong>यात्रा के दौरान शराब की खरीद या सेवन:</strong>
              <p>
                यात्रा के दौरान शराब की खरीद या सेवन सख़्त मना है। यह यात्रियों
                की सुरक्षा के लिए गंभीर जोखिम पैदा करता है और इससे दुर्घटना,
                झगड़े या कार्य में लापरवाही जैसी स्थितियाँ उत्पन्न हो सकती हैं।
              </p>
            </li>

            <li>
              <strong>
                ग्राहक की सुरक्षा और निजता (Privacy) से जुड़े मामले:
              </strong>
              <p>
                ग्राहकों की सुरक्षा या निजता से समझौता करने वाला कोई भी कार्य
                अस्वीकार्य है। इसमें शामिल हैं:
              </p>
              <ul>
                <li>ग्राहकों से उनकी निर्धारित सीट बदलने के लिए कहना</li>
                <li>उनकी अनुमति के बिना परदा खोलना</li>
                <li>
                  व्यक्तिगत जानकारी माँगना या उनकी प्राइवेसी का उल्लंघन करना
                </li>
              </ul>
            </li>

            <li>
              <strong>बिना बुकिंग वाले यात्री को बस में चढ़ाना:</strong>
              <p>
                यदि किसी मार्शल को बिना बुकिंग वाले यात्री को बस में चढ़ाते पाया
                जाता है, तो उसे तुरंत Zingbus ड्यूटी से हटा दिया जाएगा। इससे
                बचने के लिए हर यात्री की बुकिंग की जाँच करें या फिर Marshal App
                से बुकिंग बनाएं।
              </p>
            </li>
          </ol>
        </>
      ) : (
        <>
          <h1>Zero Tolerance Policy (ZTP) @ Zingbus</h1>
          <hr />
          <p>
            At Zingbus, our Zero Tolerance Policy (ZTP) defines behaviors that
            will not be accepted under any circumstances. Such cases will result
            in immediate strict action, including on-the-spot removal from duty,
            loss of pay, and permanent suspension (blacklisting).
          </p>
          <p>The following are considered ZTP cases:</p>
          <ol>
            <li>
              <strong>Verbal or Physical Assault/Abuse with Customers </strong>
              <p>
                We highly value and respect our customers, treating them as
                guests at home. No matter how angry or hyper a customer may be,
                we must never argue with them. Instead, we should respond with
                empathy, understanding the root cause of their behavior.
              </p>

              <p>
                If you feel you are unable to manage the situation, immediately
                reach out to the Crew Chat team for support. Assaulting a
                customer verbally or physically is never a solution.
              </p>
            </li>
            <li>
              <strong> Alcohol Purchase or Consumption During Trip </strong>
              <p>
                Purchasing or consuming alcohol during a trip is strictly
                prohibited. It poses serious safety risks to customers onboard
                and may lead to accidents, fights, or failure to perform job
                responsibilities.{" "}
              </p>
            </li>
            <li>
              <strong> Safety/Privacy Cases Related to Customers </strong>
              <p>
                Any action that compromises customer safety or privacy is
                unacceptable. This includes:
                <ul>- Asking customers to shift from their assigned seats</ul>
                <ul>- Opening curtains without their permission</ul>
                <ul>
                  - Requesting personal details or violating their privacy
                </ul>
              </p>
            </li>
            <li>
              <strong>Unauthorized Passenger Boarding </strong>
              <p>
                If a Marshal is found boarding passengers without valid
                bookings, they will be immediately removed from Zingbus
                duties.To avoid this please check customer valid booking in case
                of no booking use marshal app to make the instant booking.
              </p>
            </li>
          </ol>
        </>
      )}
    </div>
  );
};

export default ZtpPolicy;
